import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';

/** One flag for every lab results surface: the prescription review drawer and the in-session tab. */
export const useLabResultsEnabled = (): boolean =>
  useFeatureIsOn(GROWTHBOOK_FEATURE_FLAGS.LAB_RESULTS);
